














































































import { Teacher } from '../../../src_server/entity/generated/Teacher';
import { Component, Prop } from 'vue-property-decorator';
import { InputPages } from '../../components/organisms/InputPages';
import SimpleCheckBox from '../../components/inputs/SimpleCheckBox.vue';
import ErrorSummary from '../../components/inputs/ErrorSummary.vue';

@Component({ components: { SimpleCheckBox, ErrorSummary } })
export default class TeacherPaymentInputPage extends InputPages {
  @Prop()
  value!: Teacher;

  private options = [
    { title: '001:ガーネット支店', value: '001', name: 'ｶﾞｰﾈｯﾄ' },
    { title: '002:アメシスト支店', value: '002', name: 'ｱﾒｼｽﾄ' },
    { title: '003:アクアマリン支店', value: '003', name: 'ｱｸｱﾏﾘﾝ' },
    { title: '004:ダイヤモンド支店', value: '004', name: 'ﾀﾞｲﾔﾓﾝﾄﾞ' },
    { title: '005:エメラルド支店', value: '005', name: 'ｴﾒﾗﾙﾄﾞ' },
    { title: '006:パール支店', value: '006', name: 'ﾊﾟｰﾙ' },
    { title: '007:ルビー支店', value: '007', name: 'ﾙﾋﾞｰ' },
    { title: '008:ペリドット支店', value: '008', name: 'ﾍﾞﾘﾄﾞｯﾄ' },
    { title: '009:サファイア支店', value: '009', name: 'ｻﾌｧｲﾔ' },
    { title: '010:オパール支店', value: '010', name: 'ｵﾊﾟｰﾙ' },
    { title: '011:トパーズ支店', value: '011', name: 'ﾄﾊﾟｰｽﾞ' },
    { title: '012:ターコイズ支店', value: '012', name: 'ﾀｰｺｲｽﾞ' },
  ];

  private types = [
    { title: '1:普通', value: '1' },
    { title: '2:当座', value: '2' },
  ];

  private is_aeon = false;

  get compBankBranchCode() {
    return this.value.bank_branch_code ?? '';
  }

  set compBankBranchCode(value: string) {
    console.log('ion value', value);
    this.value.bank_code = '0040';
    this.value.bank_name = 'ｲｵﾝ';
    this.value.bank_branch = this.options.find((i) => i.value === value)?.name;
    this.value.bank_branch_code = value;
  }

  get model() {
    return this.value;
  }

  set model(value) {
    this.$emit('input', value);
  }
}
